import * as React from "react";
import clsx from "clsx";
import { Icon } from "../../icon/icon/icon.mjs";
import { Spinner } from "../../spinner/spinner.mjs";
const FormHelper = ({ id, type = "help", size = "small", text, className, ...rest }) => {
  return /* @__PURE__ */ React.createElement("div", { className: clsx("form-helper", "form-helper--".concat(type), "form-helper--".concat(size), className), id, ...rest }, type !== "help" && (type === "loading" ? /* @__PURE__ */ React.createElement(Spinner, { className: "form-helper__icon" }) : /* @__PURE__ */ React.createElement(Icon, { className: "form-helper__icon", modifiers: iconMap[type] })), /* @__PURE__ */ React.createElement("div", { className: "form-helper__content" }, text));
};
const iconMap = {
  help: "",
  // Not rendered for help
  error: "#alert-filled",
  employee: "#support",
  valid: "#check-round-filled",
  loading: ""
  // Spinner is rendered separately
};
export {
  FormHelper
};
